import uuid from 'uuid';

const CartItemDefaultValues = Object.freeze({
  categoryPath: '',
  colorId: null,
  colorName: '',
  designCompositeId: '',
  designName: '',
  designUpdatedAt: '',
  id: '',
  imageSrc: '',
  styleId: null,
  styleName: '',
  priceBeforeDiscount: '',
  quantity: 0,
  quoteQuantities: '',
  sizeDisplayName: '',
  subTotal: 0,
  unitPrice: 0,
  visible: null
});

export const createCartItem = initialValues => {
  const cartItem = {...CartItemDefaultValues};
  const validProperties = Object.keys(CartItemDefaultValues);
  validProperties.forEach(prop => {
    const assignedValue = initialValues[prop];
    if (assignedValue || assignedValue === false) {
      cartItem[prop] = assignedValue;
    }
  });
  cartItem.id = initialValues.id || uuid.v4();

  return cartItem;
};
